import { theme as defaultTheme } from "@mindlercare/ui-web";
import { ReactNode } from "react";
import { styled } from "styled-components";
import { Typography } from "components/typography";

type PatientItemPropsBase = {
  title: string;
  valueTextColor?: keyof typeof defaultTheme.COLORS;
};

type PatientItemWithValue = PatientItemPropsBase & {
  value: string | number | undefined;
  children?: never;
};

type PatientItemWithChildren = PatientItemPropsBase & {
  value?: never;
  children: ReactNode;
};

type PatientItemProps = PatientItemWithValue | PatientItemWithChildren;

export default function PatientItem({
  children,
  title,
  value,
  valueTextColor,
}: PatientItemProps) {
  return (
    <Root data-testid={title}>
      <Title>{title}</Title>
      {value ? (
        <Typography color={valueTextColor} variant="body">
          {value}
        </Typography>
      ) : (
        children
      )}
    </Root>
  );
}

const Title = styled.h3`
  margin: 0;
  padding-bottom: ${defaultTheme.PADDING.SM};
  font-size: ${defaultTheme.FONT.SIZE.SMALL};
  font-weight: ${defaultTheme.FONT.WEIGHT.REGULAR};
  color: ${defaultTheme.COLORS.GRAY_DARK};
`;

const Root = styled.div`
  float: left;
  color: ${defaultTheme.COLORS.DARK_GREEN};

  &:not(:last-of-type) {
    padding-right: ${defaultTheme.PADDING.XL};
  }

  &:last-of-type {
    padding-right: ${defaultTheme.PADDING.MD};
  }
`;
